import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Loader } from 'belle-js'
import styles from './PageContainer.module.scss'
import Link from 'redux-first-router-link'

const PageContainer = (props) => {
  const {
    hide,
    upperTitle,
    name,
    description,
    children,
    isLoading,
    prevPageInfo,
    className,
    isMobile
  } = props

  const titleStyles = upperTitle ? styles.noMarginTop : null
  const pageContainerPositionStyles = !hide ? styles.pageContainerRelative : null
  const pageContainerStyles = classnames(
    hide ? null : styles.PageContainer,
    pageContainerPositionStyles,
    className,
  )

  let prevPageText = null

  if (prevPageInfo) {
    prevPageText = `< ${prevPageInfo.showBackWord ? `Back: ` : ''}${prevPageInfo.name}`
  }

  return (
    <div className={pageContainerStyles}>
      { !hide &&
        <div className={styles.container}>
          { prevPageText && isMobile && (
            <Link
              data-test="prevPageInfo"
              className={styles.prevPage}
              to={prevPageInfo.to}>
              {prevPageText}
            </Link>
          ) }
          { upperTitle && <h4 data-test="upperTitle" className={styles.upperTitle}>{upperTitle}</h4> }
          <h1 className={titleStyles} data-test="name">{name}</h1>
          { description.length > 0 && description.map((desc, i) => (
            <p
              key={i}
              data-test="description"
              className={styles.description}>
              {desc}
            </p>
          )) }
          {children}
        </div> }
      { isLoading && <Loader /> }
    </div>
  )
}

PageContainer.defaultProps = {
  upperTitle: '',
  description: [],
  children: undefined,
  hide: false,
  isLoading: false,
  prevPageInfo: null,
  className: '',
}

PageContainer.propTypes = {
  upperTitle: PropTypes.string,
  name: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  description: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node,
  hide: PropTypes.bool,
  prevPageInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    to: PropTypes.object.isRequired,
    showBackWord: PropTypes.bool,
  }),
  className: PropTypes.string,
  isMobile: PropTypes.bool.isRequired
}

export default PageContainer



// WEBPACK FOOTER //
// ./src/components/Onboarding/PageContainer/PageContainer.jsx